import { TAGLINES } from "@/lib/site";

export const Marquee = ({ items = TAGLINES, testid = "tagline-marquee" }) => {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-b border-cloud/10 py-2.5" data-testid={testid} aria-label="Brand taglines">
      <div className="marquee-track flex animate-[marquee_90s_linear_infinite]">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={i} className="flex items-center gap-8 px-8 font-mono text-[10px] uppercase tracking-[0.3em] text-cloud/55 whitespace-nowrap">
                {t}<span className="h-1 w-1 rounded-full bg-lime" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
